import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { Title } from '@angular/platform-browser';

// service
import { AppService } from './../core/services/app.service';

// i18n
import { TranslateModule } from '@ngx-translate/core';

// perfect-scrollbar
import { NgScrollbarModule, provideScrollbarOptions } from 'ngx-scrollbar';

// headlessui
import { MenuModule } from 'headlessui-angular';

// icons
import { IconModule } from 'src/app/shared/icon/icon.module';

// PrimeNG imports for document viewer
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { Dialog } from 'primeng/dialog';
import { DialogService, DynamicDialog } from 'primeng/dynamicdialog';
import { ButtonModule } from 'primeng/button';

import { DocumentViewerDialogComponent } from './components/document-viewer-dialog/document-viewer-dialog.component';
import { PopupComponent } from './components/popup/popup.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule, 
    ReactiveFormsModule, 
    RouterModule, 
    TranslateModule.forChild(), 
    NgScrollbarModule, 
    MenuModule, 
    IconModule,
    
    // PrimeNG imports for document viewer
    ProgressSpinnerModule,
    DialogModule,
    DynamicDialog,
    Dialog,
    ButtonModule
  ],
  declarations: [
    DocumentViewerDialogComponent,
    PopupComponent
  ],
  providers: [
    DialogService
  ],
  exports: [
    // modules
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    NgScrollbarModule,
    MenuModule,
    IconModule,
    
    // PrimeNG imports for document viewer
    DocumentViewerDialogComponent,
    PopupComponent,
    ProgressSpinnerModule,
    DialogModule,
    DynamicDialog,
    Dialog,
    ButtonModule
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<any> {
    return {
      ngModule: SharedModule,
      providers: [
        Title,
        AppService,
        provideScrollbarOptions({
          visibility: 'hover',
          appearance: 'compact',
        }),
      ],
    };
  }
}
